export const SCAN_TOOL_OPTIONS = {
    "clarity": {
        key: "clarity",
        name: "Clarity",
        value: "CLARITY"
    },
    "fossid": {
        key: "fossid",
        name: "FossID",
        value: "FOSSID",
    },
    "sbom": {
        key: "sbom",
        name: "SBOM",
        value: "SBOM" 
    },
    "clarityAIR": {
        key: "clarityair",
        name: "ClarityAIR",
        value: "CLARITYAIR" 
    }
}

export const getNameScanToolByValue = (value) => {
  const tool = Object.values(SCAN_TOOL_OPTIONS).find(item => item.value === value);
  return tool ? tool.name : undefined;
}